import { FunctionComponent, PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './section-heading.style';

export interface ISharedProps {
  noMargin?: boolean;
  largeMargin?: boolean;
  lineHeight?: number;
}

interface IProps extends ISharedProps, PropsWithChildren {}

const SectionHeading: FunctionComponent<IProps> = ({
  children,
  noMargin,
  largeMargin,
  lineHeight,
}) => {
  const styles = componentStyles({ noMargin, largeMargin, lineHeight });

  return (
    <Box as="h3" style={styles.wrapper}>
      {children}
    </Box>
  );
};

export default SectionHeading;
